export default __webpack_public_path__ + "static/media/pen.31d6cfe0.svg";